var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 30C57.5 45.1878 45.1878 57.5 30 57.5C14.8122 57.5 2.5 45.1878 2.5 30C2.5 14.8122 14.8122 2.5 30 2.5C45.1878 2.5 57.5 14.8122 57.5 30ZM7.51708 30C7.51708 42.417 17.583 52.4829 30 52.4829C42.417 52.4829 52.4829 42.417 52.4829 30C52.4829 17.583 42.417 7.51708 30 7.51708C17.583 7.51708 7.51708 17.583 7.51708 30Z",
    fill: "#FFB000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5C28.6193 12.5 27.5 13.6193 27.5 15V31.1667C27.5 31.1667 27.5 31.8185 27.8168 32.3088C28.0287 32.7246 28.3593 33.0859 28.7935 33.3366L40.3429 40.0046C41.5387 40.695 43.0676 40.2853 43.758 39.0896C44.4484 37.8938 44.0387 36.3649 42.8429 35.6745L32.5 29.703V15C32.5 13.6193 31.3807 12.5 30 12.5Z",
    fill: "#FFB000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ec7181df32d5ba837ab2919a81afb982.svg";
export { ForwardRef as ReactComponent };